/**
 * ForgotPasswordPage component.
 * This component is used to render the forgot password page.
 *
 * @module components/ForgotPasswordPage
 */

import React, { useRef, useState } from "react";
import { sendResetPasswordEmail } from "../../../api/userApi";
import { Link } from "react-router-dom";
import { Form, FormLabel } from "react-bootstrap";
import "./ForgotPasswordPage.scss";
import GPLogo from "../../../assets/images/logo/gp-logo-trans-w100.webp";
import Lock from "../../../assets/images/forgotpassword/send.png";
import { ToastContainer, toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import "react-toastify/dist/ReactToastify.min.css";
import useTranslation from "../../../hooks/useTranslation";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);
  const { t } = useTranslation("loginRelatedPages", true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if CAPTCHA is completed
    if (!captchaToken) {
      toast.error(t("captchaNotCompleted"));
      return;
    }

    try {
      const response = await sendResetPasswordEmail(email, captchaToken);
      // Display a success message regardless of the specific status code
      toast.info(t("forgotYourPasswordSuccess"));
    } catch (error) {
      console.error(error);
      toast.error(t("forgotYourPasswordError")); // Display an error message if something goes wrong
    }
  };

  // Handle CAPTCHA change
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  return (
    <div className="bg-div-forgotpassword-page">
      {/*  <ToastContainer /> */}
      <div className="container forgot-password-page__container">
        <div className="forgot-password-page__content__container">
          <img
            src={GPLogo}
            alt="GP Logo"
            className="forgot-password-page__logo"
          />
          <img src={Lock} alt="Lock" className="forgot-password-page__lock" />
          <h1 className="login-page__form-title">{t("forgotYourPassword")}</h1>
          <p className="login-page__form-subtitle ">
            {t("forgotYourPasswordSubtitle")}
          </p>
          <Form onSubmit={handleSubmit}>
            <FormLabel htmlFor="email">{t("emailaddress")}:</FormLabel>
            <Form.Control
              id="email"
              type="email"
              placeholder={t("emailPlaceholder")}
              required
              autoComplete="on"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
              className="forgot-password-page__captcha"
            />
            <button type="submit" className="btn btn-primary">
              {t("send")}
            </button>
          </Form>
          <div className="forgot-password-page__login-link">
            <Link to="/" className="btn btn-secondary">
              {t("backToLogin")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
